import React, { useState } from 'react';
import MetaTags from 'react-meta-tags';
import { Link, useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { AagencyForgot } from '../../apis/Agency';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Typography,
  TextField,
  Grid,
  Button,
  InputAdornment,
  Divider,
  Box
} from '@mui/material';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './Login.css';
import { base_url, base_logo_url } from '../../apis/constants';

const ResetPassword = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [isMailError, setIsMailError] = useState(false);
  const [mailError, setMailError] = useState('');
  const [linkSent, setLinkSent] = useState(false);

  const handleSuccessResetPass = res => {
    setIsLoading(false);
    setLinkSent(true);
  };

  const handleErrorResetPass = err => {
    setIsLoading(false);
    setIsMailError(true);
    setMailError(err.response.data.reasonPhrase);
  };

  const handleForgotPass = e => {
    e.preventDefault();
    setIsMailError(false);
    setMailError('');
    setIsLoading(true);
    AagencyForgot(usernameOrEmail)
      .then(res => res.status === 200 && handleSuccessResetPass(res))
      .catch(err => handleErrorResetPass(err));
  };

  return (
    <React.Fragment>
      <ToastContainer
        position='top-center'
        style={{ width: 'auto' }}
        autoClose={4800}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Background */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundImage: `url(${base_logo_url}carrier_logos/TMS-backg-img.png)`,
          backgroundSize: '100% 110%',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0
        }}
      />

      <div style={{ position: 'relative', zIndex: 1 }}>
        <MetaTags>
          <title>Reset Password | TMS Shipping</title>
        </MetaTags>

        <section
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Grid
            container
            sx={{
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: { xs: 2, sm: 4 }
            }}
          >
            <Grid
              item
              xs={12}
              sm={7}
              md={5}
              lg={4}
              xl={3}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255,255,255,0.97)',
                borderRadius: '16px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                padding: { xs: '32px 20px', sm: '48px 36px' }
              }}
            >
              <div style={{ width: '100%' }}>
                {/* Logo */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '-12px',
                    marginBottom: '24px'
                  }}
                >
                  <svg
                    width='240'
                    height='62'
                    viewBox='0 0 1080 360'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    style={{ display: 'block', margin: '0 auto' }}
                  >
                    <defs>
                      <linearGradient
                        id='resetLogoGrad'
                        x1='82'
                        y1='72'
                        x2='288'
                        y2='278'
                        gradientUnits='userSpaceOnUse'
                      >
                        <stop offset='0' stopColor='#1297FF' />
                        <stop offset='1' stopColor='#006CFF' />
                      </linearGradient>
                    </defs>
                    <g
                      transform='translate(38 20) scale(.625)'
                      stroke='url(#resetLogoGrad)'
                      strokeWidth='54'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      fill='none'
                    >
                      <path d='M176 108 L256 188 L336 108' />
                      <path d='M108 176 L188 256 L108 336' />
                      <path d='M336 404 L256 324 L176 404' />
                      <path d='M404 336 L324 256 L404 176' />
                    </g>
                    <text
                      x='365'
                      y='220'
                      fill='#000000'
                      fontFamily='Inter, Arial, Helvetica, sans-serif'
                      fontSize='118'
                      letterSpacing='-4'
                    >
                      <tspan fontWeight='700'>Ship</tspan>
                      <tspan fontWeight='400'>TechPro</tspan>
                    </text>
                  </svg>
                </div>

                {linkSent ? (
                  /* ── Success screen ── */
                  <>
                    {/* Email sent icon */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <Box sx={{
                          width: 64, height: 64, borderRadius: '50%',
                          bgcolor: '#e8f5e9', display: 'flex',
                          alignItems: 'center', justifyContent: 'center'
                        }}>
                          <EmailOutlinedIcon sx={{ fontSize: 34, color: '#2e7d32' }} />
                        </Box>
                        <CheckCircleIcon sx={{
                          position: 'absolute', bottom: -2, right: -2,
                          fontSize: 22, color: '#4caf50', bgcolor: 'white', borderRadius: '50%'
                        }} />
                      </Box>
                    </Box>

                    <Typography variant='h6' sx={{ fontWeight: 700, textAlign: 'center', mb: 0.5, color: '#111' }}>
                      Reset Link Sent!
                    </Typography>
                    <Typography variant='body2' sx={{ textAlign: 'center', color: '#555', mb: 0.5, lineHeight: 1.6 }}>
                      We've sent a password reset link to
                    </Typography>
                    <Typography variant='body2' sx={{ textAlign: 'center', fontWeight: 700, color: '#111', mb: 1 }}>
                      {usernameOrEmail}
                    </Typography>
                    <Typography variant='body2' sx={{ textAlign: 'center', color: '#555', mb: 2, lineHeight: 1.6, fontSize: '0.82rem' }}>
                      Please check your inbox and follow the instructions to reset your password.
                    </Typography>

                    <Divider sx={{ mb: 2 }} />

                    {/* Didn't receive box */}
                    <Box sx={{
                      display: 'flex', alignItems: 'flex-start', gap: 1.5,
                      bgcolor: '#f5f7ff', borderRadius: '8px',
                      p: '10px 14px', mb: 2.5
                    }}>
                      <EmailOutlinedIcon sx={{ fontSize: 20, color: '#3361FF', mt: 0.3, flexShrink: 0 }} />
                      <Typography variant='caption' sx={{ color: '#555', lineHeight: 1.6 }}>
                        <strong>Didn't receive the email?</strong><br />
                        Check your spam, junk folder or promotions tab.<br />
                        If you still can't find it, you can{' '}
                        <span
                          onClick={() => { setLinkSent(false); }}
                          style={{ color: '#3361FF', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}
                        >
                          resend the link
                        </span>.
                      </Typography>
                    </Box>

                    <Button
                      fullWidth
                      variant='contained'
                      onClick={() => history.push('/agency-signin')}
                      startIcon={<ArrowBackIcon />}
                      style={{
                        borderRadius: '8px', padding: '8px',
                        fontSize: '15px', fontWeight: 600, textTransform: 'none'
                      }}
                    >
                      Back to Login
                    </Button>
                  </>
                ) : (
                  /* ── Form screen ── */
                  <>
                    <Typography variant='h5' sx={{ fontWeight: 700, textAlign: 'center', mb: 1, color: '#111' }}>
                      Forgot Password?
                    </Typography>
                    <Typography variant='body2' sx={{ textAlign: 'center', color: '#666', mb: 3, lineHeight: 1.6 }}>
                      No worries! Enter your email address and
                      <br />
                      we'll send you a link to reset your password.
                    </Typography>

                    <Form style={{ width: '100%' }} onSubmit={handleForgotPass}>
                      <div style={{ marginBottom: '20px' }}>
                        <Typography variant='caption' style={{ fontWeight: 600, color: '#333' }}>
                          Email <span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          error={isMailError}
                          id='email'
                          value={usernameOrEmail}
                          onChange={e => setUsernameOrEmail(e.target.value)}
                          placeholder='Enter your email address'
                          variant='outlined'
                          size='small'
                          required
                          helperText={mailError}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position='start'>
                                <EmailOutlinedIcon style={{ color: '#aaa', fontSize: 20 }} />
                              </InputAdornment>
                            )
                          }}
                          style={{ marginTop: '6px' }}
                        />
                      </div>

                      <Button
                        fullWidth
                        disabled={!usernameOrEmail}
                        type='submit'
                        variant='contained'
                        style={{
                          borderRadius: '8px', padding: '8px',
                          fontSize: '15px', fontWeight: 600,
                          textTransform: 'none', marginBottom: '16px'
                        }}
                      >
                        {isLoading ? 'Sending...' : 'Send Reset Link'}
                      </Button>

                      <Divider sx={{ mb: 2, color: '#999', fontSize: '13px' }}>OR</Divider>

                      <Box sx={{ textAlign: 'center' }}>
                        <Link
                          to='/agency-signin'
                          style={{
                            color: '#3361FF', fontSize: '14px',
                            textDecoration: 'none', display: 'inline-flex',
                            alignItems: 'center', gap: '4px', fontWeight: 500
                          }}
                        >
                          <ArrowBackIcon style={{ fontSize: 16 }} />
                          Back to Login
                        </Link>
                      </Box>
                    </Form>
                  </>
                )}
              </div>
            </Grid>
          </Grid>
        </section>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
